import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { ThemeProvider } from "./context/ThemeContext";

// Shared reports have their own entry point: no workspace authentication,
// billing, navigation or analytics is mounted for a client viewing a report.
const WorkspaceApp = lazy(() => import("./WorkspaceApp"));
const SharedCareReport = lazy(() => import("./pages/SharedCareReport"));

export function ApplicationRoutes() {
  return (
    <Suspense
      fallback={
        <Box
          role="status"
          sx={{ minHeight: "60vh", display: "grid", placeItems: "center" }}
        >
          <CircularProgress aria-label="Loading page" />
        </Box>
      }
    >
      <Routes>
        <Route path="/care-report/:id" element={<SharedCareReport />} />
        <Route path="/care-report/*" element={<SharedCareReport />} />
        <Route path="*" element={<WorkspaceApp />} />
      </Routes>
    </Suspense>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <Router>
        <ApplicationRoutes />
      </Router>
    </ThemeProvider>
  );
}
